/**
 * Entry point: wires the manifest and GameScene into the SDK.
 *
 * The shell scenes (MainMenu, Lobby, GameOver…) use the default platform
 * theme; the in-game scene paints its own racetrack background so the two
 * look distinct without feeling jarring.
 */
import { bootGame } from '@platform/sdk';
import GameScene from './GameScene.js';
import manifest from '../manifest.json';

bootGame({
  manifest,
  GameScene,
  parent: 'game'
});
